import React from 'react';

const Facebook = () => {
    return (
        <svg
            width="20"
            height="42"
            viewBox="0 0 20 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.75921 21.0377V40.5459C4.75921 40.8271 4.98613 41.054 5.26732 41.054H12.5117C12.7916 41.054 13.0198 40.8271 13.0198 40.5459V20.7195H18.2724C18.5363 20.7195 18.7558 20.5172 18.778 20.2545L19.2837 14.2804C19.3096 13.9845 19.074 13.7292 18.7768 13.7292H13.0198V9.49157C13.0198 8.49754 13.8251 7.6922 14.8192 7.6922H18.8656C19.1468 7.6922 19.3737 7.46527 19.3737 7.18531V1.21124C19.3737 0.930051 19.1468 0.703125 18.8656 0.703125H12.0258C8.01263 0.703125 4.75921 3.95655 4.75921 7.96969V13.7292H1.13702C0.857066 13.7292 0.628906 13.9573 0.628906 14.2373V20.2114C0.628906 20.4925 0.857066 20.7195 1.13702 20.7195H4.75921V21.0377Z"
                fill="url(#paint0_linear_13763_941)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_13763_941"
                    x1="10.0013"
                    y1="41.054"
                    x2="10.0013"
                    y2="0.703125"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#022139" />
                    <stop offset="1" stop-color="#014B86" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Facebook;
